import { render, staticRenderFns } from "./PINResetForm.vue?vue&type=template&id=00cd5b5b&scoped=true"
import script from "./PINResetForm.vue?vue&type=script&lang=js"
export * from "./PINResetForm.vue?vue&type=script&lang=js"
import style0 from "./PINResetForm.vue?vue&type=style&index=0&id=00cd5b5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd5b5b",
  null
  
)

export default component.exports